// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import AsyncFilterSearchController from "./async_filter_search_controller"
application.register("async-filter-search", AsyncFilterSearchController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)
